import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import UserLandingPage from './user/UserLandingPage';
import AdminLogin from './admin/AdminLogin';
import AdminDashboard from './admin/AdminDashboard'; 
import Employees from './admin/Employees';
import HowToUse from './admin/HowToUse';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<UserLandingPage />} />
        <Route path="/adminlogin" element={<AdminLogin />} />
        <Route path="/admindashboard" element={<AdminDashboard />} />
        <Route path="/employees" element={<Employees />} />
        <Route path="/howtouse" element={<HowToUse />} />
      </Routes>
    </Router>
  );
}

export default App;
